<template>
    <LayoutDefault>
        <b-card-group deck>
            <b-card class="p-0 col-md-3 shadow">
                <template v-slot:header>
                    <p class="text-primary font-weight-bold mb-0">
                        {{ $t('home.bem_vindo.titulo') }}
                    </p>
                </template>
                <b-card-text>
                    <p>
                        {{ $t('home.bem_vindo.paragrafo1') }}
                    </p>
                    <p>
                        {{ $t('home.bem_vindo.paragrafo2') }}
                    </p>
                </b-card-text>
            </b-card>
            <b-card class="shadow">
                <template v-slot:header>
                    <p class="text-primary font-weight-bold mb-0">
                        {{ $t('home.novidades.titulo') }}
                    </p>
                </template>
                <TimeLine :events="[{
                    title: this.$t('home.novidades.rnds.titulo'),
                    date: this.$t('home.novidades.rnds.data'),
                    text: this.$t('home.novidades.rnds.texto')
                },{
                    title: this.$t('home.novidades.lancamento.titulo'),
                    date: this.$t('home.novidades.lancamento.data'),
                    text: this.$t('home.novidades.lancamento.texto')
                },{
                    title: this.$t('home.novidades.monitoramento.titulo'),
                    date: this.$t('home.novidades.monitoramento.data'),
                    text: this.$t('home.novidades.monitoramento.texto')
                },{
                    title: this.$t('home.novidades.dashboard.titulo'),
                    date: this.$t('home.novidades.dashboard.data'),
                    text: this.$t('home.novidades.dashboard.texto')
                }]" />
            </b-card>
        </b-card-group>
    </LayoutDefault>
</template>

<script>
    import LayoutDefault from "@/templates/LayoutDefault";
    import TimeLine from "@/components/TimeLine";

    export default {
        name: "Home",
        components: {TimeLine, LayoutDefault}
    }
</script>

<style lang="scss" scoped>
</style>
